import { render, staticRenderFns } from "./spread-center-inner.vue?vue&type=template&id=fca2c574"
import script from "./spread-center-inner.vue?vue&type=script&lang=js"
export * from "./spread-center-inner.vue?vue&type=script&lang=js"
import style0 from "./spread-center-inner.vue?vue&type=style&index=0&id=fca2c574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports